module.exports = __webpack_public_path__ + "static/media/map-pin-white-dot-large.030b980a.svg";